import { Counties, County } from 'models/plans-search-types';
import { TokenResult } from 'models/applynow.model';
import { dataFetcherGet } from 'lib/data-fetcher';

const baseUrl = process.env['PUBLIC_URL'] || '';

export const getCounties = async (zipcode: string, planType: string): Promise<County[]> => {
  const apiUrl = `${baseUrl}/sc-api/custom/zipcodecounty/getcounties/${zipcode}?planType={${planType}}`;

  try {
    const { data } = await dataFetcherGet<Counties>(apiUrl);
    const { counties } = data;

    return counties || [];
  } catch {
    return [];
  }
};

export const getEvolveURL = async (prefix: string, apiHost = ''): Promise<TokenResult> => {
  const apiUrl = `${apiHost ? apiHost : baseUrl}/sc-api/custom/evolvetokengenerator/gettoken/${prefix}`;

  const { data } = await dataFetcherGet<TokenResult>(apiUrl);

  data.evolvePreview =
    baseUrl.indexOf('localhost') > 0 || baseUrl.indexOf('://dev') > 0 || baseUrl.indexOf('://test') > 0;

  return data;
};
